var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0703 3.47375C7.65031 3.47375 4.07031 5.26375 4.07031 7.47375V17.4738C4.07031 19.6838 7.66031 21.4738 12.0703 21.4738C16.4803 21.4738 20.0703 19.6838 20.0703 17.4738V7.47375C20.0703 5.26375 16.4903 3.47375 12.0703 3.47375ZM18.0703 17.4738C18.0703 17.9738 15.9403 19.4738 12.0703 19.4738C8.20031 19.4738 6.07031 17.9738 6.07031 17.4738V15.2438C7.68031 16.0238 9.79031 16.4738 12.0703 16.4738C14.3503 16.4738 16.4603 16.0238 18.0703 15.2438V17.4738ZM18.0703 12.9238C16.7703 13.8738 14.4903 14.4738 12.0703 14.4738C9.65031 14.4738 7.37031 13.8738 6.07031 12.9238V10.1138C7.54031 10.9438 9.68031 11.4738 12.0703 11.4738C14.4603 11.4738 16.6003 10.9438 18.0703 10.1138V12.9238ZM12.0703 9.47375C8.20031 9.47375 6.07031 7.97375 6.07031 7.47375C6.07031 6.97375 8.20031 5.47375 12.0703 5.47375C15.9403 5.47375 18.0703 6.97375 18.0703 7.47375C18.0703 7.97375 15.9403 9.47375 12.0703 9.47375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.b1e05b70.svg";
export { ForwardRef as ReactComponent };